import styled, { css } from 'styled-components';
import { Text } from '../Text';

const StyledTitle = styled(Text)`
	display: flex;
	align-items: center;
	gap: 4px;
	font-size: 16px;
	color: #ffffff;
	transition: color 0.3s ease;

	span {
		&:nth-child(2) {
			opacity: 0.5;
		}
	}
`;

const StyledTitleText = styled.span<{ $isNew?: boolean }>`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: ${(props) => (props.$isNew ? '185px' : '210px')};
	display: inline-block;
`;

const StyledPrice = styled(Text)`
	font-weight: 700;
	font-size: 16px;
	color: #ffffff;
	transition: color 0.3s ease;
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-left: auto;

	img {
		transition: filter 0.3s ease;
	}
`;

const StyledContainer = styled.div<{
	$invertCurrency?: boolean;
	$active?: boolean;
	$installed?: boolean;
	$selectable?: boolean;
}>`
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	height: 40px;
	min-height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	${(props) =>
		props.$active &&
		css`
			background-color: #2d70da;
		`}

	${(props) =>
		props.$selectable &&
		css`
			cursor: pointer;

			&:hover {
				background-color: #ffffff;

				${StyledTitle}, ${StyledPrice} {
					color: #000000;
				}

				${StyledInstalledContainer} {
					${Text} {
						color: #000000;
					}

					img {
						filter: invert(100%);
					}
				}

				${props.$invertCurrency &&
				css`
					${StyledPriceContainer} {
						img {
							filter: invert(100%);
						}
					}
				`}
			}
		`}
`;

const StyledNewContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	min-width: 34px;
	height: 20px;
	background-color: #eb1818;
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 10px;
		color: #ffffff;
	}
`;

const StyledInstalledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-left: auto;
	opacity: 0.5;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-size: 16px;
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

export {
	StyledContainer,
	StyledInstalledContainer,
	StyledNewContainer,
	StyledPrice,
	StyledPriceContainer,
	StyledTitle,
	StyledTitleText,
};
